export default {
  title: 'Profit Centres',
  subTitle: 'Lorem ipsum dolor',
  totalPages: '{{offset}}-{{totalPages}} of {{total}}',
  archivingReasonTitle: 'Specify reason for archiving',
  archivingReasonDescription: 'Please provide a reason for archiving the selected record(s). You can restore '
      + 'them anytime.',
  archiveDetails: 'Archived record details',
  editInformation: 'Edit Information',
  fieldsHeaders: {
    logicalName: 'Logical Name',
    uniqueProfitCentre: 'Unique Profit Centre',
    valueChainPosition: 'Value Chain Position',
    ownership: 'Ownership',
    equityShareholding: 'Equity Shareholding %',
    financialControl: 'Financial Control %',
    numberOfEmployees: 'No. of Employees',
    dateOpened: 'Date Opened',
    dateClosed: 'Date Closed',
    sector: 'Sector (NACE)',
    industry: 'Industry (NACE)',
    euTaxonomyActivityCode: 'EU Taxonomy Activity Code',
    fyStartDate: 'FY Start Date',
    fyEndDate: 'FY End Date',
    relatedBalanceSheetAssets: 'Related Balance Sheet Assets',
    totalRevenue: '% of Total Revenue',
    actualRevenue: 'Actual Revenue',
    totalGrossProfit: '% of Total Gross Profit',
    actualGrossProfit: 'Actual Gross Profit',
    stock: 'Stock',
    countryOfOperation: 'Country of Operation / Incorporation',
    stateRegionCounty: 'State / Region / County',
    city: 'City',
    postCode: 'Post Code',
    street: 'Street',
    buildingName: 'Building Name / Number',
    coordinates: 'Coordinates',
    actions: 'Actions',
  },
  createProfitCentre: {
    title: 'Create New Profit Centre',
    editTitle: 'Edit Profit Centre',
    detailsPanel: 'Details',
    generalPanel: 'General',
    financialsPanel: 'Financials',
    fields: {
      name: 'Logical Name',
      uniqueIdentifier: 'Unique Profit Centre',
      totalRevenue: '% of Total Revenue',
      actualRevenue: 'Actual Revenue',
      totalGross: '% of Total Gross Profit',
      actualGross: 'Actual Gross Profit',
      goodsStock: 'WIP/Finished Goods Stock',
      structure: 'Structure (select the parent node)',
      valueChainSection: 'Value Chain Position',
      ownership: 'Ownership',
      equityShareholdingCurrency: 'Equity Shareholding %',
      financialControlCurrency: 'Financial Control %',
      numberOfEmployees: 'No. of Employees',
      dateOpened: 'Date Opened',
      dateClosed: 'Date Closed',
      sector: 'Sector (NACE)',
      industry: 'Industry (NACE)',
      euTaxonomyActivityCode: 'EU Taxonomy Activity Code',
      startDate: 'FY Start Date',
      endDate: 'FY End Date',
      address: 'Address',
      country: 'Country of Operation / Incorporation',
      state: 'State / Region / County',
      postCode: 'Post Code',
      city: 'City',
      street: 'Street',
      building: 'Building Name / Number',
      coordinates: 'Coordinates',
      relatedBalanceSheetAssets: 'Related Balance Sheet Assets',
      stock: 'Stock',
      taxesCode: 'Code',
      formateDate: 'dd-mm-yyyy',
      valueChainList: 'Value Chain List',
    },
  },
};
